import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRoutes } from './routes/AppRoutes';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { appCssVariablesResolver, appMantineTheme } from './mantineTheme';

// Add Mantine Styles
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';

const App: React.FC = () => {
    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Caveat:wght@400..700&family=Mogra&family=Poppins:wght@300;400;500;600;700&family=Red+Hat+Display:ital,wght@1,300..900&family=Sahitya:wght@400;700&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <MantineProvider theme={appMantineTheme} cssVariablesResolver={appCssVariablesResolver}>
            <Notifications />
            <Router>
                <AppRoutes />
            </Router>
        </MantineProvider>
    );
};

export default App;
